import {i18next} from 'common/i18n';
import {LocalizationStore} from 'common/i18n/store';
import {NamedError} from 'common/report/queries/utils/named-error';

import i18nTranslationKeys from './index.i18n';

const reportI18n = new LocalizationStore(i18next).scoped(i18nTranslationKeys);

/** The error the server answers with when a sensitive change needs a fresh step-up reauth. */
export const REAUTH_REQUIRED_ERROR = `reauth_required`;

/**
 * Thrown by `fetchWithReauth` when the user cancels the reauth prompt. Callers skip their
 * error handling for it: nothing changed, by choice.
 */
export class ReauthCancelledError extends NamedError {
  constructor() {
    super(`Reauth prompt cancelled`);
    // Literal so Sentry's name-based ignore filter survives bundler minification.
    this.name = `ReauthCancelledError`;
  }
}

export function isReauthCancelledError(err: unknown): err is ReauthCancelledError {
  return err instanceof ReauthCancelledError;
}

/**
 * `fetchWithReauth` prompts on `reauth_required` and retries once, so a caller only sees one
 * when the retry still needs a reauth, e.g. because the org's allowed reauth methods
 * changed while the prompt was open.
 */
export function reauthFailedMessage(): string {
  return reportI18n.t(`settings.org-settings.verify-identity.rejected`);
}
